import React from 'react';
import { twMerge } from 'tailwind-merge';

export function IconChild({ onClick, className, color = '#000' }) {
  return (
    <svg
      onClick={onClick}
      className={twMerge(' w-6 h-6', className)}
      fill="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 9C7.65 9 8.475 9 8.987 8.487C9.5 7.975 9.5 7.15 9.5 5.5C9.5 3.85 9.5 3.025 8.987 2.513C8.475 2 7.65 2 6 2C4.35 2 3.525 2 3.013 2.513C2.5 3.025 2.5 3.85 2.5 5.5C2.5 7.15 2.5 7.975 3.013 8.487C3.525 9 4.35 9 6 9ZM6 9V14M6 14C5.314 14 4.76 14.552 3.657 15.657C2.552 16.761 2 17.314 2 18C2 18.686 2.552 19.24 3.657 20.343C4.761 21.448 5.314 22 6 22C6.686 22 7.24 21.448 8.343 20.343C9.448 19.239 10 18.686 10 18M6 14C6.686 14 7.239 14.552 8.343 15.657C9.448 16.76 10 17.314 10 18M10 18H15M15 18C15 16.35 15 15.525 15.513 15.013C16.025 14.5 16.85 14.5 18.5 14.5C20.15 14.5 20.975 14.5 21.487 15.013C22 15.525 22 16.35 22 18C22 19.65 22 20.475 21.487 20.987C20.975 21.5 20.15 21.5 18.5 21.5C16.85 21.5 16.025 21.5 15.513 20.987C15 20.475 15 19.65 15 18Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
